<template>
    <div class="form-group col-12">
        <button
            class="btn btn-info btn-static waves-effect waves-light mt-2 mb-3"
            @click="onAddButtonClick"
        >
            <i class="fas fa-plus" />
            Change
        </button>
        <div class="row">
            <div class="col-12 col-xl-4 form-group">
                <label for="isReported">
                    Are Default Stars Added
                </label>
                <b-badge
                    pill
                    class="my-1 px-3 form-control d-flex align-items-center  justify-content-center"
                    :variant="file.areStarsAdded ? 'success' : 'danger'"
                >
                    {{ file.areStarsAdded ? 'YES' : 'NO' }}
                </b-badge>
            </div>
            <div class="col-12 col-xl-4 form-group">
                <label for="likesThreshold">Likes Threshold</label>
                <input
                    id="likesThreshold"
                    v-model="file.likesThreshold"
                    type="number"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('likesThreshold')
                    }"
                    :disabled="file.areStarsAdded"
                    min="1"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('likesThreshold') }}
                </div>
            </div>
            <div class="col-12 col-xl-4 form-group">
                <label for="starsAmount">Stars Amount</label>
                <input
                    id="starsAmount"
                    v-model="file.starsAmount"
                    type="number"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('starsAmount')
                    }"
                    :disabled="file.areStarsAdded"
                    min="1"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('starsAmount') }}
                </div>
            </div>
        </div>

        <manage-stars-modal
            :user-id="user.id"
            :success-message="`Stars changed for ${user.fullName}!`"
        />
    </div>
</template>

<script>
import ManageStarsModal from '@/components/users/ManageStarsModal';

export default {
    components: {
        ManageStarsModal
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            file: {}
        };
    },

    watch: {
        file() {
            this.$emit('input', this.file);
        }
    },

    created() {
        this.file = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.file[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.file,
                this.serverErrors,
                key
            );
        },

        onAddButtonClick() {
            this.$bvModal.show('manage-stars-modal');
        }
    }
};
</script>
